<template>
  <div>
    <div v-if="readonly" class="c-i">
      <v-icon>{{ icons[selected] }}</v-icon>
    </div>
    <v-select v-else v-model="selected" :items="values" :disabled="disabled" color="clr-primary" class="c-no-margin">
      <template slot="selection" slot-scope="v">
        <v-icon>{{ icons[v.item] }}</v-icon>
      </template>
      <template slot="item" slot-scope="v">
        <v-icon>{{ icons[v.item] }}</v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: ['value', 'readonly', 'disabled'],
  data() {
    return {
      selected: this.value ? this.value : 0,
      values: [0, 1, 2, 3],
      icons: ['mdi-minus', 'mdi-circle-outline', 'mdi-triangle-outline', 'mdi-window-close'],
    };
  },
  mounted() {
    this.$emit('input', this.selected);
  },
  watch: {
    value(n, o) {
      this.selected = n;
    },
    selected(n, o) {
      this.$emit('input', n);
    },
  },
  method: {
    toStatus(v) {
      return this.icons[v];
    },
  },
};
</script>

<style scoped>
.c-i i {
  font-size: 18px;
}
</style>
